import { DialogContext, IIdentity } from '.';

export interface DialogComponent<T extends IIdentity> {
  context: DialogContext<T>;
}
